import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

export const useAdminRightsState = () => {
  const ctx = useAppContext();
  const adminQuery: any = useMeaQuery(
    `@result=[SC.${ctx?.modelId || ""}];
        @result+=[UM].currentuser;
        @result;`,
    "permissionlevels,accesslevel",
    undefined,
    { enabled: !!ctx?.modelId }
  );
  const isAdmin =
    adminQuery?.data?.data?.filter(
      (item: any) =>
        (item.id?.indexOf("SC") > -1 && item.accesslevel === "Administrate") ||
        (item.id?.indexOf("UM") && item.permissionlevels?.indexOf("SC=2") > -1)
    ).length > 0;

  const isLoading = !!ctx?.modelId && !!adminQuery?.isLoading && !adminQuery?.data;

  return { isAdmin, isLoading };
};

const useAdminRights = () => {
  const { isAdmin } = useAdminRightsState();
  return isAdmin;
};

export default useAdminRights;
